import {Button, Collapse, Space, Typography} from "antd";
import React, {useState} from "react";
import ObjectDetails from "./ObjectDetails";
import s from "../mobile.module.css";
import {CheckSquareOutlined} from "@ant-design/icons";

const {Panel} = Collapse;
const {Text} = Typography;

const ObjectProps = ({handleAddReport, object, handleViewOldReports, todayReport, hasTodayReport}) => {
    const [isPanelOpen, setIsPanelOpen] = useState(false);

    const handleHeaderClick = (e) => {
        // Открываем/закрываем панель только если клик не по кнопке
        if (!e.target.closest('button')) {
            setIsPanelOpen(!isPanelOpen);
        }
    };

    return (
        <Collapse accordion className={s.objectsCollapse}>
            <Panel
                key={object.id}
                showArrow={false}
                isActive={isPanelOpen}
                header={
                    <div onClick={handleHeaderClick} style={
                        {
                            width: '100%',
                            cursor: 'pointer',
                            padding: '5px',
                        }
                    }>
                        <Space style={{width: '100%', justifyContent: 'space-between'}}>
                            <Space>
                                <Text strong>{object.name}</Text>
                                {object.long_name && <Text type="secondary">({object.long_name})</Text>}
                                {todayReport && <div  style={{position: "absolute", right: 10, color: 'green'}}><CheckSquareOutlined /></div>}
                            </Space>
                        </Space>
                    </div>
                }
            >
                <ObjectDetails object={object}/>

                <Space direction="vertical" style={{width: '100%', marginTop: 16}}>
                    <Button
                        type="primary"
                        block
                        onClick={() => handleAddReport(object.id, object.name, todayReport)}
                    >
                        {hasTodayReport ? "✏️ Изменить отчет" : "📝 Загрузить отчет"}
                    </Button>
                    <Button
                        block
                        onClick={() => handleViewOldReports(object.id, object.name)}
                    >
                        📋 Прошлые отчеты
                    </Button>
                </Space>
            </Panel>

        </Collapse>


    );
};

export default ObjectProps;